// 1. IMPORTS
import React, { useEffect, useState } from "react";
import { Alert, Card, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { buildVietQRUrl } from "helper/vietqr";
import { DIGITS_PATTERN } from "helper/UtilsFunctionsValidation";

// 2. COMPONENT & STATES
function PaymentMethodBankQrPreview({ bank, account, accountName }) {
  const { t: translation } = useTranslation();
  const [qrImage, setQrImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  // 4. EVENT HANDLERS
  const handleImageLoad = () => {
    setLoading(false);
  };

  const handleImageError = () => {
    setLoading(false);
    setHasError(true);
    setQrImage(null);
  };

  // 5. SIDE EFFECTS
  useEffect(() => {
    setQrImage(null);
    setHasError(false);
    setLoading(false);

    if (!bank || !DIGITS_PATTERN.test(account || "") || !accountName?.trim()) {
      return;
    }

    setLoading(true);
    const timer = setTimeout(() => {
      setQrImage(buildVietQRUrl({ bank, account, accountName }));
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [bank, account, accountName]);

  // 8. MAIN JSX
  return (
    <Card className="mb-3" title={translation("paymentMethod.atmBank.qrPreviewTitle")}>
      {loading && <Spin tip={translation("paymentMethod.atmBank.qrPreviewLoading")} />}
      {hasError && (
        <Alert type="error" message={translation("paymentMethod.atmBank.qrPreviewError")} />
      )}
      {qrImage && (
        <div className="text-center">
          <img
            key={qrImage}
            className="img-fluid"
            src={qrImage}
            onLoad={handleImageLoad}
            onError={handleImageError}
            alt={translation("paymentMethod.atmBank.qrPreviewTitle")}
          />
        </div>
      )}
      {!loading && !hasError && !qrImage && translation("paymentMethod.atmBank.qrPreviewEmpty")}
    </Card>
  );
}

// 9. EXPORTS
export default PaymentMethodBankQrPreview;